import React,{useState,useEffect} from 'react';
import Axios from 'axios';
import CommentInput from './CommentInput';
import CommentBlock from './CommentBlock';
import LoaderCircle from '../../ui-elements/LoaderCircle';
import removeUrls from '../../../utils/removeUrls';

function ListMainComments({volume,book,hadith,cmntCat,cmntMode,componentMode}){
    const [volNum,setVolNum] = useState("");
    const [bookNum,setBookNum] = useState("");
    const [hadithNum,setHadithNum] = useState("");
    const [isInitiatedAyah, setIsInitiatedAyah]=useState(false);
    const [isCommentLoaded,setIsCommentLoaded]=useState(false);
    const [commentData,setCommentData]=useState(["empty"]);
    const [commentMode,setCommentMode]=useState("");
    const [userId,setUserId]=useState(null);
    const [isCommentModalOpen,setIsCommentModalOpen]=useState(true);
    const [alimToken,setAlimToken]=useState(null);
    const [commentCat,setCommentCat]=useState(null);
    const [nextPage,setNextPage]=useState(1);
    const [isCommentsLoading,setIsCommentsLoading]=useState(false);
    const [isLastPage,setIsLastPage]=useState(false);
    const [totalComments,setTotalComments]=useState(0);

    const initComment=()=>{
        const searchParams = new URLSearchParams(document.location.search);
        setVolNum(volume);
        setBookNum(book);
        setHadithNum(hadith);
        componentMode?setCommentMode(componentMode):setCommentMode(searchParams.get('cmtMd'));
        setCommentCat(cmntCat);
        setUserId(localStorage.getItem('alim-user-email'));
        setAlimToken(localStorage.getItem('alim-login-token'));
        setIsInitiatedAyah(true);
    }

    const getComments=(pageNo,pageSize=10)=>{
        if(isInitiatedAyah)
        {
            setIsCommentsLoading(true);
            Axios.post(`${alimAPIBaseURI}rpc/get_hadith_comments_by_cat_with_count`, {volnum:volNum,booknum:bookNum,hadithnum:hadithNum,cmtype:"0",cmcat:commentCat,page_number:pageNo,page_size:pageSize},{headers: {"Content-Type": "application/json"}}).then((data)=>{
                setTotalComments(data.data[0].total_count);
                if(commentData[0]==="empty"||pageNo===1)
                {
                    setCommentData(data.data[0].comments)
                }
                else
                {
                    setCommentData([...commentData,...data.data[0].comments]);
                }
                setNextPage(pageNo+1);
                setIsCommentsLoading(false);
            });
        }
    }

    const reloadComments=()=>{
        setIsCommentLoaded(false);
        getComments(1);
    }

    const closeModalWithRefresh=()=>{
        //setIsCommentModalOpen(!isCommentModalOpen);
        reloadComments();
    }

    const timeAgo=(input)=>{
        const date = (input instanceof Date) ? input : new Date(input);
        const formatter = new Intl.RelativeTimeFormat('en');
        const ranges = {
            years: 3600 * 24 * 365,
            months: 3600 * 24 * 30,
            weeks: 3600 * 24 * 7,
            days: 3600 * 24,
            hours: 3600,
            minutes: 60,
            seconds: 1
        };
        const secondsElapsed = (date.getTime() - Date.now()) / 1000;
        for (let key in ranges) {
            if (ranges[key] < Math.abs(secondsElapsed)) {
                const delta = secondsElapsed / ranges[key];
                return formatter.format(Math.round(delta), key);
            }
        }
    }

    const getTitle=(category,volume,book,hadith)=>{
        let titleStr="";
        switch(category){
            case "AMH": titleStr=`Al-Muwatta Hadith ${volume}:${hadith}`;break;
            case "FQS": titleStr=`Fiqh-us-Sunnah Hadith ${volume}:${hadith}`;break;
            case "SHB": titleStr=`Sahih Bukhari Hadith ${volume}:${book}:${hadith}`;break;
            case "NWH": titleStr=`An-Nawawi Hadith ${hadith}`;break;
            case "TIR": titleStr=`Al-Tirmidhi Hadith ${book}:${hadith}`;break;
            case "HDQ": titleStr=`Qudsi Hadith ${hadith}`;break;
            case "SAD": titleStr=`Abu Dawood Hadith ${book}:${hadith}`;break;
            case "NAS": titleStr=`Nasai Hadith ${book}:${hadith}`;break;
            case "MAJ": titleStr=`Ibn Majah Hadith ${book}:${hadith}`;break;
            case "SHM": titleStr=`Sahih Muslim Hadith ${book}:${hadith}`;break;
            default: titleStr=category;break;
        }
        return titleStr;
    }

    useEffect(()=>{
        const loginHandler=()=>{
            setUserId(localStorage.getItem('alim-user-email'));
            setAlimToken(localStorage.getItem('alim-login-token'));
        }
        document.addEventListener("alim-login",loginHandler);

        return()=>{
            document.removeEventListener("alim-login", loginHandler);
        }
    });

    useEffect(()=>{
        initComment();
    },[]);

    useEffect(()=>{
        getComments(nextPage);
    },[isInitiatedAyah]);

    useEffect(()=>{
        setIsCommentLoaded(true);
        if(commentData.length>=totalComments)
        {
            setIsLastPage(true);
        }
        else
        {
            setIsLastPage(false);
        }
    },[commentData])

    useEffect(()=>{

    },[isCommentLoaded]);

    if(isInitiatedAyah)
    {
        if(commentData.length>0&&commentData[0]!=="empty"&&isCommentLoaded)
        {
            return (
                <div>
                    <div className='mb-10'>
                        <div className={`flex justify-end items-center flex-wrap gap-3 ${isCommentModalOpen?"mb-6":""}`}>
                            {!isCommentModalOpen&&<button onClick={()=>{setIsCommentModalOpen(!isCommentModalOpen)}} className='bg-deep-red rounded-md px-5 py-2 text-white'>
                                Post comment
                            </button>}
                        </div>
                        {
                            isCommentModalOpen&&<CommentInput volume={volNum} book={bookNum} hadith={hadithNum} commentCat={cmntCat} closeWithRefresh={closeModalWithRefresh} closeFunc={setIsCommentModalOpen}/>
                        }
                    </div>

                    <div className='grid grid-cols-12 gap-3'>
                    {
                        commentData.map((comment,index)=>{
                            return (
                                <CommentBlock key={index} first_name={comment.first_name} second_name={comment.second_name} comment_time={timeAgo(new Date(Number(comment.comment_time)).toISOString())} comment_data={removeUrls(comment.comment_data,comment.user_id)} comment_id={comment.comment_id} like_count={comment.like_count} cmnt_count={comment.cmnt_count} comment_mode={commentMode} vol_num={comment.vol_num} book_num={comment.book_num} hadith_num={comment.hadith_num} col_num="2" home_page="0" profile_pic={comment.profile_picture} user_id={userId} web_token={alimToken} comment_cat={comment.category} title_func={getTitle} webToken={alimToken} comment_user={comment.user_id} current_user={userId} comment_parent={comment.comment_parent}/>
                            );
                        })
                    }
                    </div>

                    {
                        !isLastPage?
                        <>
                            {!isCommentsLoading&&
                                <div className='col-span-12 flex justify-center pt-6' onClick={()=>{getComments(nextPage)}}>
                                    <button className="bg-deep-red px-5 py-2 rounded-md text-white">
                                        Load more
                                    </button>
                                </div>
                                
                            }
            
                            {isCommentsLoading&&
                                <div className='col-span-12 flex justify-center pt-6'>
                                    <LoaderCircle/>
                                </div>
                            }
                        </>
                        :
                        null
                    }
                </div>
            );
        }
        else if(isCommentLoaded&&commentData.length===0)
        {
            return (
                <div>
                    <div className='mb-16'>
                        {
                            isCommentModalOpen&&<CommentInput volume={volNum} book={bookNum} hadith={hadithNum} commentCat={cmntCat} closeWithRefresh={closeModalWithRefresh} closeFunc={setIsCommentModalOpen}/>
                        }
                        <div className={`flex justify-between items-center flex-wrap gap-3 ${isCommentModalOpen?"mt-6":""}`}>

                            <p>No comments posted</p>

                            {!isCommentModalOpen&&<button onClick={()=>{setIsCommentModalOpen(!isCommentModalOpen)}} className='bg-deep-red rounded-md px-5 py-2 text-white'>
                                Post comment
                            </button>}
                        </div>
                    </div>
                </div>
            );
        }
    }
    else
    {
        return (
            <div>
                <div id={"commentLoader"} className="flex p-2 space-x-2 items-center justify-center h-full w-full">
                    <span className="alim-pre-loader animate-spin"></span>
                    <span className="alim-text-color-style text-2xl font-bold">Loading Comments.</span>
                </div>
            </div>
        )
    }
}

export default ListMainComments;